import { Component, Inject } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { UploadDialog } from '../upload-dailog.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
})
export class FaqComponent {
  loaded = false;

  buttonClicked = false;
  success = false;
  status;

  faq = {
    client: null as any,
    type: null as any,
    file: null as any,
  }; 

  clients = JSON.parse(sessionStorage.getItem('clients'));
  devices = [
    { dname: 'Android', id: 'android' },
    { dname: 'IOS', id: 'ios' },
    { dname: 'All', id: 'all' },
  ];

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.mixpanel.track('page_view', {
      page: 'FAQ',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
  }

  upload(status: boolean) {
    this.status = status;
    if (status) {
      const formData = new FormData();
      formData.append('device', this.faq.type);
      formData.append('client', this.faq.client);
      formData.append('htmlFile', this.faq.file);
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buttonClicked = true;
          this.mixpanel.track('button_click', {
            page: 'FAQ',
            category: 'Dashboard',
            button: 'Upload',
          });
          this.apiCall(formData);
        } else {
          //pass
        }
      });
    } else {
      this.mixpanel.track('button_click', {
        page: 'FAQ',
        category: 'Dashboard',
        button: 'Preview',
      });
      const reader = new FileReader();
      reader.onload = (e) => {
        this._bottomSheet.open(FaqPreview, {
          data: this.sanitizer.bypassSecurityTrustHtml(e.target.result as string),
        });
      };
      reader.readAsText(this.faq.file);
    }
  }

  apiCall(formData) {
    this.api.faq(formData).subscribe(
      (data: any) => {
        this.buttonClicked = false;
        this.success = true;
        if (data.status) {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'success',
          });
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }

  remove() {
    this.faq.file = null;
  }

  onFileSelected(event: any): void {
    this.faq.file = event.target.files[0] ?? null;
  }
}

@Component({
  selector: 'faq-preview',
  templateUrl: './faq-preview.html',
})
export class FaqPreview {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FaqComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: []
  ) {  }

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
